<template>
  <v-row>
    <v-col class="detail-text" style="overflow-y: auto">
      <v-sheet class="ma-4" elevation="5" rounded="lg" style="display: grid; grid-template-columns: 100%">
        <v-container>
          <v-row v-if="isadministrator || issuperadministrator || isOwner" class="my-0 pa-0" no-gutters justify="end" align="center">
            <v-checkbox
              v-model="showDeleted"
              label="Show deleted"
              color="green-lighten-1"
              density="compact"
              hide-details
              class="mr-4"
              :disabled="!haveDeletedLogs"
            >
            </v-checkbox>
            <v-checkbox
              v-model="showEdits"
              label="Show edits"
              color="green-lighten-1"
              density="compact"
              hide-details
              class="mr-4"
              :disabled="!haveEditedLogs"
            >
            </v-checkbox>
            <ExportButton
                v-if="isadministrator || issuperadministrator"
                table-type="internal-log"
                :other="{ selectedIssue: this.selecteditem, showDeleted: this.showDeleted, showEdits: this.showEdits }"
                :export-message="'Export Log'"
              >
          </ExportButton>
          </v-row>
          <v-row
            v-for="(issueValue, issueKey) in selectedItemLogsFiltered"
            :key="issueKey"
            class="my-0 pa-1 issue-log-hover"
            no-gutters
            justify="space-between"
            @blur="resetIssueLogEdits()"
          >
            <div style="width: 80%">
              <p class="ma-0" style="font-size: 0.75rem; color: #666">
                {{ issueValue.createdDate }} [{{ issueValue.userName }}]
              </p>
              <div v-if="!issueValue.isEditing">
                <p v-if="issueValue.isRoot">
                  <span v-if="showEdits">
                    <p class="edited-log-item">
                      <span :class="{ 'deleted-log-item' : issueValue.deleted }">
                        {{ issueValue.message }}
                      </span>                  
                      <span style="font-size: 0.8rem; font-style: normal">
                        (edited) [{{ issueValue.versions[0].createdDate }}]
                      </span>
                      <span v-if="issueValue.deleted" class="deleted-log-item" style="font-size: 0.8rem; font-style: normal">
                        (deleted) [{{ issueValue.deletedDate }}]
                      </span>
                    </p>
                    <p v-for="(version, index) in issueValue.versions" :key="index" :class="{ 'edited-log-item': index < issueValue.versions.length - 1 }">
                      <span :class="{ 'deleted-log-item' : version.deleted }">
                        {{ version.message }}
                      </span>
                      <span v-if="index < issueValue.versions.length -1" style="font-size: 0.8rem; font-style: normal">
                        (edited) [{{ issueValue.versions[issueValue.versions.length - 1].createdDate }}]
                      </span>
                      <span v-if="version.deleted" class="deleted-log-item" style="font-size: 0.8rem; font-style: normal">
                        (deleted) [{{ version.deletedDate }}]
                      </span>
                    </p>
                  </span>
                  <span v-else>
                    <span :class="{ 'deleted-log-item' : issueValue.deleted }">
                      {{ issueValue.versions[issueValue.versions.length - 1].message }}
                    </span>
                    <span style="font-size: 0.8rem; color: #666">
                      (edited) [{{ issueValue.versions[issueValue.versions.length - 1].createdDate }}]
                    </span>
                    <span v-if="issueValue.deleted" class="deleted-log-item" style="font-size: 0.8rem; font-style: normal">
                      (deleted) [{{ issueValue.deletedDate }}]
                    </span>
                  </span>
                </p>
                <p v-else class="ma-0">
                  <span :class="{ 'deleted-log-item' : issueValue.deleted }">{{ issueValue.message }}</span>
                  <span v-if="issueValue.deleted" style="font-size: 0.8rem; font-style: normal">
                    (deleted) [{{ issueValue.deletedDate }}]
                  </span>
                </p>
              </div>
              <div v-else>
                <p v-if="issueValue.isRoot">
                  <span v-if="showEdits">
                    <p class="edited-log-item">
                      <span>
                        {{ issueValue.message }}
                      </span>                  
                      <span style="font-size: 0.8rem; font-style: normal">
                       (edited) [{{ issueValue.versions[0].createdDate }}]
                      </span>
                    </p>
                    <p v-for="(version, index) in issueValue.versions" :key="index" class="edited-log-item">
                      <span v-if="index < issueValue.versions.length -1">
                        {{ version.message }}
                        <span style="font-size: 0.8rem; font-style: normal">
                          (edited) [{{ issueValue.versions[issueValue.versions.length - 1].createdDate }}]
                        </span>
                      </span>
                    </p>
                  </span>
                </p>
                <v-text-field
                  v-model="issueLogMessageEdit"
                  label="Edit Note"
                  hide-details
                  clearable
                  @click="isIssueLogMessageEditable = true"
                  @blur="isIssueLogMessageEditable = false"
                  style="width: 100%; margin: 0 15px"
                >
                </v-text-field>
                <div
                  v-if="isIssueLogMessageEditable"
                  justify="end"
                  style="
                    display: flex;
                    width: 100%;
                    margin: 0 15px;
                    justify-content: flex-end;
                    transform: translate(-2px, 0px);
                  "
                >
                  <v-btn
                    class="icon_buttons floating_buttons"
                    :icon="true"
                    color="white"
                    ref="text_field_confirm"
                    @mousedown.prevent="saveEditedIssueLogMessage(issueValue)"
                    style="margin: 6px 8px 6px 8px; width: fit-content; height: fit-content"
                  >
                    <v-icon color="grey darken-1" style="padding-right: 1px; margin: 2px"> mdi-check </v-icon>
                  </v-btn>
                  <v-btn
                    class="icon_buttons floating_buttons"
                    :icon="true"
                    color="white"
                    ref="text_field_cancel"
                    @mousedown.prevent="cancelEditedIssueLogMessage()"
                    style="margin: 6px 8px 6px 8px; width: fit-content; height: fit-content"
                  >
                    <v-icon color="grey darken-1" style="padding-right: 1px; margin: 2px"> mdi-close </v-icon>
                  </v-btn>
                </div>
              </div>
            </div>
            <div style="display: flex">
              <div v-if="issueValue.canEdit">
                <v-tooltip
                  text="Edit"
                  location="top"
                  :open-delay="tooltipOpenDelayDataTable"
                  :disabled="issueValue.systemMsg"
                >
                  <template v-slot:activator="{ props }">
                    <div v-bind="props" @click.stop="toggleEditingIssueLogItem(issueValue)" style="padding: 6px 10px">
                      <v-icon
                        color="grey-darken-1"
                        size="30px"
                        class="issue-log-button"
                        :disabled="issueValue.systemMsg"
                        >mdi-pencil</v-icon
                      >
                    </div>
                  </template>
                </v-tooltip>
              </div>
              <div v-if="issueValue.canDelete">
                <v-tooltip
                  text="Delete"
                  location="top"
                  :open-delay="tooltipOpenDelayDataTable"
                  :disabled="issueValue.systemMsg"
                >
                  <template v-slot:activator="{ props }">
                    <div v-bind="props" @click.stop="deleteIssueLogItem(issueValue)" style="padding: 6px 10px">
                      <v-icon
                        color="grey-darken-1"
                        size="30px"
                        class="issue-log-button"
                        :disabled="issueValue.systemMsg"
                        >mdi-delete</v-icon
                      >
                    </div>
                  </template>
                </v-tooltip>
              </div>
            </div>
          </v-row>
          <v-row v-if="selectedItemLogs.length === 0" class="my-2" no-gutters>
            <p class="ma-0">No notes or logs for this issue yet.</p>
          </v-row>
          <v-row
            ><v-text-field
              v-model="issueLogMessage"
              label="New Note"
              hide-details
              clearable
              @focus="onNewNoteFocus()"
              ref="new_note_text_field"
              style="margin: 0 15px"
            ></v-text-field
          ></v-row>
          <v-row justify="end"
            ><v-btn
              prepend-icon="mdi-send"
              rounded="0"
              style="margin: 15px"
              @click="saveIssueLogMessage"
              :disabled="!issueLogMessage"
              >Submit</v-btn
            ></v-row
          >
        </v-container>
      </v-sheet>
    </v-col>
  </v-row>
</template>

<script>
import { HTTP } from "@/plugins/backendAPI";
import { mapGetters } from "vuex";
import ExportButton from "./ExportButton.vue";

export default {
  components: {
    ExportButton
  },
  data() {
    return {
      issueLogMessage: null,
      tooltipOpenDelayDataTable: 200,
      isIssueLogMessageEditable: false,
      issueLogMessageEdit: null,
      showDeleted: false,
      showEdits: false,
    };
  },
  props: {
    selecteditem: {
      type: Object,
      required: true,
    },
    issueLogs: {
      type: Array,
      required: true,
    },
  },
  computed: {
    ...mapGetters(["workspaceid", "organizationid", "username", "isadministrator", "issuperadministrator", "isOwner", "loading"]),
    selectedItemLogs() {
      const selectedItemLogs = this.issueLogs.filter((log) => log.issueId === this.selecteditem.id);
      const editedLogs = new Set(selectedItemLogs.map((log) => log.editedFromId).filter(Boolean));
      const rootLogs = new Set(selectedItemLogs.map((log) => log.rootId).filter(Boolean));

      selectedItemLogs.forEach((log) => {
        const isEdited = editedLogs.has(log.id);
        const isRoot = rootLogs.has(log.id);
        log.isEdited = isEdited;
        log.isRoot = isRoot;
        log.canEdit =
          log.userEmail === this.$store.getters.username && !log.deleted && !log.systemMsg && (!isEdited || isRoot);
        log.canDelete = log.userEmail === this.$store.getters.username && !log.deleted && !log.systemMsg;
      });
      return selectedItemLogs;
    },
    ongoingMessageEdits() {
      return this.selectedItemLogs.some(
        (log) =>
          log.isEditing &&
          ((log.isRoot && log.versions[log.versions.length - 1].message !== this.issueLogMessageEdit) ||
            (!log.isRoot && log.message !== this.issueLogMessageEdit))
      );
    },
    selectedItemLogsFiltered() {
      let items = this.selectedItemLogs.filter(
        (log) => (!log.isEdited && log.rootId === null) || (log.isEdited && log.isRoot)
      );
      if (!this.showDeleted) {
        items = items.filter((log) => !log.deleted);
      }
      return items;
    },
    haveDeletedLogs() {
      return this.selectedItemLogs.some((log) => log.deleted);
    },
    haveEditedLogs() {
      return this.selectedItemLogsFiltered.some((log) => log.isEdited);
    },
  },
  emits: ["issueLogsUpdated"],
  methods: {
    saveIssueLogMessage() {
      if (!this.issueLogMessage) return;
      this.$store.dispatch("setLoading", true);
      HTTP.post("/issuelogs/create", {
        id: 0,
        issueId: this.selecteditem.id,
        message: this.issueLogMessage,
        organizationId: this.organizationid,
      })
        .then(() => {
          this.issueLogMessage = null;
          this.$emit("issueLogsUpdated");
        })
        .catch((e) => {
          this.$store.dispatch("showError", "Error when saving note: " + (e.response.data.message ?? e.response.data));
        })
        .finally(() => {
          this.$store.dispatch("setLoading", false);
        });
    },
    saveEditedIssueLogMessage(item) {
      if (!this.issueLogMessageEdit) return;
      this.$store.dispatch("setLoading", true);
      HTTP.post("/issuelogs/edit", {
        id: 0,
        issueId: item.issueId,
        message: this.issueLogMessageEdit,
        organizationId: this.organizationid,
        editedFromId: item.isRoot ? item.versions[item.versions.length - 1].id : item.id,
        rootId: item.id,
      })
        .then(() => {
          this.issueLogMessageEdit = null;
          this.resetIssueLogEdits();
          this.$emit("issueLogsUpdated");
        })
        .catch((e) => {
          this.$store.dispatch("showError", "Error when editing note: " + (e.response.data.message ?? e.response.data));
        })
        .finally(() => {
          this.$store.dispatch("setLoading", false);
        });
    },
    cancelEditedIssueLogMessage() {
      this.resetIssueLogEdits();
    },
    deleteIssueLogItem(item) {
      if (item.deleted) return;

      if (this.ongoingMessageEdits) {
        this.$root.$ConfirmDialog
          .open("Delete note", "You have unsaved changes. Do you want to discard them and delete the note?", {
            color: "red",
          })
          .then((response) => {
            if (response) {
              this.resetIssueLogEdits();
              this.confirmDeleteIssueLogItem(item);
            }
          });
      } else {
        this.$root.$ConfirmDialog.open("Delete note", "Are you sure?", { color: "red" }).then((response) => {
          if (response) {
            this.confirmDeleteIssueLogItem(item);
          }
        });
      }
    },
    confirmDeleteIssueLogItem(item) {
      this.$store.dispatch("setLoading", true);
      HTTP.post("/issuelogs/delete", {
        id: item.id,
        issueId: item.issueId,
        servicemeUserId: item.servicemeUserId,
        message: item.message,
        organizationId: this.organizationid,
        systemMsg: item.systemMsg,
      })
        .then(() => {
          this.$emit("issueLogsUpdated");
        })
        .catch((e) => {
          this.$store.dispatch(
            "showError",
            "Error when deleting note: " + (e.response.data.message ?? e.response.data)
          );
        })
        .finally(() => {
          this.$store.dispatch("setLoading", false);
        });
    },
    toggleEditingIssueLogItem(item) {
      if (item.isEditing) {
        if (this.ongoingMessageEdits) {
          this.$root.$ConfirmDialog
            .open("Stop editing note", "All unsaved edits will be lost. Are you sure?", { color: "red" })
            .then((response) => {
              if (response) {
                this.resetIssueLogEdits();
              }
            });
        } else {
          this.resetIssueLogEdits();
        }
      } else {
        if (this.ongoingMessageEdits) {
          this.$root.$ConfirmDialog
            .open("Start editing note", "You have unsaved edits. Do you want to discard them and edit another note?", {
              color: "red",
            })
            .then((response) => {
              if (response) {
                this.resetIssueLogEdits();
                this.issueLogMessageEdit = item.isRoot ? item.versions[item.versions.length - 1].message : item.message;
                item.isEditing = true;
              }
            });
        } else {
          this.resetIssueLogEdits();
          this.issueLogMessageEdit = item.isRoot ? item.versions[item.versions.length - 1].message : item.message;
          item.isEditing = true;
        }
      }
    },
    resetIssueLogEdits() {
      this.selectedItemLogs.forEach((log) => (log.isEditing = false));
      this.issueLogMessageEdit = null;
      this.isIssueLogMessageEditable = false;
    },
    onNewNoteFocus() {
      if (this.ongoingMessageEdits) {
        this.$root.$ConfirmDialog
          .open("Add new note", "You have unsaved edits. Do you want to discard them and add a new note?", {
            color: "red",
          })
          .then((response) => {
            if (response) {
              this.resetIssueLogEdits();
              this.$refs.new_note_text_field.focus();
            }
          });
      } else {
        this.resetIssueLogEdits();
        this.$refs.new_note_text_field.focus();
      }
    },
  },
};
</script>
